<template>
  <div class="exhibit-component-container">
    <div class="header">
      <div class="tabs">
        <button
          v-for="topic in topics"
          :key="topic.id"
          :class="{ active: topic === activeTopic }"
          @click="select(topic)"
          v-html="topic.title"
        />
      </div>
    </div>
    <div
      v-if="activeTopic"
      class="topic"
      v-html="activeTopic.content"
    />
  </div>
</template>

<script>
export default {
  props: {
    grouping: {
      type: Object,
    },
  },
  data() {
    return {
      selectedTopic: null,
    };
  },
  computed: {
    activeTopic() {
      return this.selectedTopic || this.topics[0];
    },
    assetAssociations() {
      if (this.grouping) {
        const assetAssociations = this.grouping.assetAssociations.filter(aa => aa.assetBType === 'Topic');
        return assetAssociations.sort((a, b) => a.order - b.order);
      } else {
        return [];
      }
    },
    topics() {
      return this.assetAssociations.map(aa => this.$store.getters['topics/topics'][aa.assetBId]).filter(t => t);
    },
  },
  methods: {
    select(topic) {
      this.selectedTopic = topic;
    },
  },
};
</script>

<style lang='scss' scoped>
  .exhibit-component-container {
    .header {
      background: #273142;
      height: rem-calc(64);
      padding-right: rem-calc(64);

      .tabs {
        @include hide-scrollbar();
        display: flex;
        flex-flow: row nowrap;
        overflow-x: auto;
      }

      button {
        background: #273142;
        border-bottom: 4px solid #273142;
        color: rgba(175, 175, 175, 1);
        flex-shrink: 0;
        height: 100%;
        line-height: rem-calc(44);
        padding: rem-calc(8) rem-calc(24);

        &:hover {
          border-color: rgba(175, 175, 175, 1);
        }

        &.active {
          border-color: white;
          color: white;
        }
      }
    }

    .topic {
      box-sizing: border-box;
      height: calc(100% - #{rem-calc(64)});
      overflow-y: auto;
      padding: rem-calc(16);
      position: absolute;
    }
  }
</style>
